import { render, staticRenderFns } from "./MarshalList.vue?vue&type=template&id=05089cc9&scoped=true&"
import script from "./MarshalList.vue?vue&type=script&lang=js&"
export * from "./MarshalList.vue?vue&type=script&lang=js&"
import style0 from "./MarshalList.vue?vue&type=style&index=0&id=05089cc9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05089cc9",
  null
  
)

export default component.exports